<template>
  <div class="act-info__file" :style="fileStyle" @click="clickHandler">
    <template v-if="!canView">
      <feather-icon icon="FileTextIcon" class="act-info__file-icon"/>
      <div class="act-info__file-ext">{{file.name | fileExt}}</div>
    </template>

    <feather-icon icon="TrashIcon" class="act-info__file-delete" @click.stop.prevent="deleteFile" v-if="canDelete"/>

    <div class="act-info__file-view-overlay" v-if="canView">
      <feather-icon icon="EyeIcon" class="act-info__file-view-icon"/>
    </div>
    <div class="act-info__file-view-overlay" v-else-if="canDownload">
      <feather-icon icon="DownloadIcon" class="act-info__file-view-icon" />
    </div>

    <img :src="imageSource" alt="" class="hidden" v-if="canView" ref="image" v-viewer="{toolbar: false, navbar: false}">


  </div>
</template>

<script>
  import 'viewerjs/dist/viewer.css';
  import Viewer from 'v-viewer';
  import Vue from 'vue';

  Vue.use(Viewer, {
    defaultOptions: {
      zIndex: 999999999
    }
  });

  const IAMGES_CAN_VIEW = [
      'jpg',
      'jpeg',
      'png',
      'gif'
  ];

  export default {
    name: "UploadedFileBlock",
    props: {
      file: {},
      canDelete: {
        type: Boolean,
        default: true
      }
    },
    data(){
      return {
        imageSource: null
      }
    },
    computed: {
      canDownload(){
        return !(this.file instanceof File);
      },
      canView(){
        let paths = this.file.name.split('.');
        return IAMGES_CAN_VIEW.includes((paths.pop()).toLowerCase());
      },
      fileStyle(){
        if(this.canView){
          return {
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundImage: `url(${this.imageSource})`
          }
        }
      },
    },
    methods: {
      show () {
        const viewer = this.$refs.image.$viewer;
        viewer.show()
      },
      updateFileSource(){
        if(this.canView){
          if(this.file instanceof File){
            let image = new Image();
            let reader = new FileReader();
            let vm = this;

            reader.onload = (e) => {
              vm.imageSource = e.target.result;
            };
            reader.readAsDataURL(this.file);
          }
          else{
            this.imageSource = this.$options.filters.imgPath(this.file.path);
          }
        }
        else{
          this.imageSource = null;
        }
      },
      deleteFile(){
        this.$emit('delete-file');
      },
      downloadFile(){
        let link = document.createElement('a');
        link.style.display = 'none';
        link.setAttribute('href', this.$options.filters.imgPath(this.file.path));
        link.setAttribute('download', this.file.name);
        link.setAttribute('target', '_blank');
        document.body.appendChild(link);
        link.click();
        setTimeout(function() {
          link.remove();
        }, 500);
      },
      clickHandler(){
        if(this.canView){
          this.show();
        }
        else if(this.canDownload){
          this.downloadFile();
        }
      }
    },
    mounted(){
      this.updateFileSource();
    },
    filters: {
      fileExt(name){
        let paths = name.split('.');
        return (paths.pop()).toUpperCase();
      }
    },
    watch: {
      file: {
        deep: true,
        handler(){
          this.updateFileSource();
        }
      }
    }
  }
</script>
